// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

import type { schemaFormAllSurfaces } from "@/components/ecv2/components/schemaFormEC/hocs/schemaFormControlSurfaces";
import type { InferSurfacesType } from "@/components/ecv2/engine/surfaceFramework/atoms/useSurfaceAtoms";
import type { ModelDataTypes } from "@/endlaFunctions/customTypings/databaseNew";
import type { ModelName } from "@/endlaFunctions/customTypings/ecTypes";
import type { ModelDocument } from "@/components/ecv2/ecModelTypes";
import type { RequiredLocalStateOptions } from "@/components/ecv2/endlaTypes";

export type SchemaFormDraftSubmit = (input: {
  model: ModelName;
  draftPk: PrimaryKey;
}) => Promise<void>;

export enum SchemaFormPersistence {
  Manual = "manual",
  Auto = "auto",
}

export enum SchemaFormPresentation {
  Standard = "standard",
  Detail = "detail",
}

export type SchemaFormECLocalStateOptions = RequiredLocalStateOptions & {
  pk?: PrimaryKey;
  model: ModelName;
  hiddenFields?: string[];
  visibleFields?: readonly string[];
  createOmitFields?: string[];
  defaults?: Record<string, unknown>;
  disableVisibilityChange: boolean;
  schema?: ModelDataTypes;
  onSaveCallback?: (savedPk: PrimaryKey | undefined) => void;
  submitDrafts?: SchemaFormDraftSubmit;
  submitLabel?: string;
  submitSuccessMessage?: string;
  saveControlsPlacement?: "top" | "bottom";
  persistence?: SchemaFormPersistence;
  presentation?: SchemaFormPresentation;
  embedded?: boolean;
  getEmptyDocument?: () => Partial<ModelDocument>;
};

export type SchemaFormECLocalState = {
  user: Record<string, never>;
  none: Record<string, never>;
} & InferSurfacesType<typeof schemaFormAllSurfaces>;

export type SchemaFormECLocalAtoms = Record<string, never>;
